import { PIEVE_MODEL_MAP, PIEVE_SENTINEL_MODELS } from '@shared/pieve/modelCatalog.js';
import getModelOptionById from '@/lib/model/getModelOptionById.js';

const MODEL_IDS = [...Object.keys(PIEVE_SENTINEL_MODELS), ...Object.keys(PIEVE_MODEL_MAP)];

const getModelOptions = ({ includeHidden = false, advancedMode = false } = {}) => {
  return MODEL_IDS.map((modelId) => getModelOptionById({ modelId, includeHidden, advancedMode })).filter(Boolean);
};

export default getModelOptions;
